import { useState, useEffect, useMemo } from "react";
import { BOOK_URL, CLASS_PRIORITY, FALLBACK_SESSIONS, normalizeLive } from "./data";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Fetches the live Pivot feed (falling back to the static schedule) and derives
// the ordered list of filter-chip class names.
export function useTimetableData() {
  const [live, setLive] = useState(null); // null=loading, object=loaded, false=error

  useEffect(() => {
    let active = true;
    fetch(`${API}/timetable`)
      .then((r) => (r.ok ? r.json() : Promise.reject(r.status)))
      .then((d) => { if (active) setLive(d); })
      .catch(() => { if (active) setLive(false); });
    return () => { active = false; };
  }, []);

  const isLoading = live === null;
  // An empty feed (term break, upstream glitch) must not wipe the timetable — treat it as "not live".
  const isLive = !!(live && Array.isArray(live.sessions) && live.sessions.length > 0);
  const bookingUrl = (live && live.bookingUrl) || BOOK_URL;

  useEffect(() => {
    if (live && Array.isArray(live.sessions) && live.sessions.length === 0) {
      console.warn("Timetable: live feed returned no sessions; showing typical schedule instead");
    }
  }, [live]);

  const allSessions = useMemo(
    () => (isLive ? normalizeLive(live.sessions) : FALLBACK_SESSIONS),
    [live, isLive]
  );

  const chipClasses = useMemo(() => {
    const set = new Set(allSessions.map((s) => s.cls));
    const ordered = CLASS_PRIORITY.filter((n) => set.has(n));
    const extras = [...set].filter((n) => !CLASS_PRIORITY.includes(n)).sort();
    return [...ordered, ...extras];
  }, [allSessions]);

  return { isLoading, isLive, bookingUrl, allSessions, chipClasses };
}
